export default __webpack_public_path__ + "static/media/weekly-icon.e0ba90bf.svg";